import _             from 'underscore';
import React, { FC } from 'react';
import { Container } from 'semantic-ui-react';
import { Link }      from 'react-router-dom';

import { RouterUtility }              from '../../../util';
import { useCurrentUser }             from '../../../hooks';
import { SemanticUISize }             from '../../../types';
import { Page }                       from '../../containers';
import { SystemAdminsOnly }           from '../../components/util/access/RoleAccessControl';
import { CHARACTER_VISUAL_AID }       from '../../components/product/CorvalCharacterVisualAid';
import { DescriptiveVisualNav }       from '../../components/nav/DescriptiveVisualNav';
import { CorvalStylizedHexContainer } from '../../components/product/CorvalStylizedHexContainer';

const AdminIndexPage: FC = ( props ) => {
	
	let {
		    isSystemCorvalAdmin,
		    isSystemDEMAdmin,
		    isSystemAccountsAdmin,
	    } = useCurrentUser()
	
	return (
		<SystemAdminsOnly redirect={ RouterUtility.getRoutePath( 'HOME' ) as string }>
			
			<Page name={ 'admin-home' }>
				
				<CorvalStylizedHexContainer fill={ 'area' } size={ SemanticUISize.MINI } fadeDirection={ 'down' }/>
				
				<Container>
					
					<DescriptiveVisualNav
						visualAid={ null }
						header={ 'Administration' }
						introCopy={ <Link to={ RouterUtility.getRoute( 'HOME' ) }>Go Home</Link> }
						navObjects={ _.compact( [
							
							( !isSystemCorvalAdmin() ) ? {
								label:       'Go Back Home',
								description: 'Return to the home area',
								routePath:   RouterUtility.getRoute( 'HOME' ),
								visualAid:   CHARACTER_VISUAL_AID.CORVAL_HEX_HELPING_USER,
							} : null,
							
							( isSystemCorvalAdmin() || isSystemDEMAdmin() ) ? {
								
								label:       'Decision Engine Manager',
								description: <>Update the Corval platform's logic between commercialization ideas.</>,
								routePath:   RouterUtility.getRoute( 'ADMIN.DECISION_ENGINE' ),
								visualAid:   CHARACTER_VISUAL_AID.CORVAL_SHAPES_Q_AND_A,
							} : null,
							
							( isSystemCorvalAdmin() || isSystemAccountsAdmin() ) ? {
								
								label:       'Account Management',
								description: <>Manage users, organizations, and projects.<br/>Update access to Corval Platform.</>,
								routePath:   RouterUtility.getRoute( 'ADMIN.SYSTEM_ACCOUNTING' ),
								visualAid:   CHARACTER_VISUAL_AID.CORVAL_HEX_INTERFACING_WITH_USERS,
							} : null,
						
						] ) }
					/>
				
				
				</Container>
			
			</Page>
		
		</SystemAdminsOnly>
	)
}

export default AdminIndexPage;
